// Annotation context utilized throughout the annotating process
import React from 'react';
export const AnnotationContext = React.createContext();
